module.exports = __webpack_public_path__ + "static/media/red_warning.e8596771.svg";